// removed by extract-text-webpack-plugin
module.exports = {"select":"_37tti-select","default":"_3eczu-default","select-content":"n3lsm-select-content","placeholder":"_2jeh3-placeholder","select-container":"qzxst-select-container","select-item":"_3-tlt-select-item","active":"_3ms-P-active","icons":"xWZzT-icons","select_icon":"Bf4sB-select_icon","select_icon--wallet":"DQ-C3-select_icon--wallet","opened":"_2c7Xd-opened","material":"_1Mmbp-material","bar":"_1IKSA-bar","select-items-container":"_2rtz7-select-items-container","ios":"_2o5kN-ios","select-wrapper":"X1SwE-select-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/SelectInput/SelectInput.scss
// module id = 824
// module chunks = 0